import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NetworkInfoService {
  get isConnectionSlow(): boolean {
    return false;
  }

  constructor() {}

  public async init() {}
}
